/** @jsxImportSource @emotion/react */
/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from "prop-types";
import { ReactComponent as IconLoop } from "assets/icons/Loop.svg";
import { iconCss, inputCss, wrapperCss } from "./index.css";

export default function SearchInputWithClickableIcon({ className, onIconClick, ...props }) {
  return (
    <div css={wrapperCss} className={className}>
      <input css={inputCss} className="text" type="text" placeholder="Search" {...props} />

      <button
        type="button"
        css={[iconCss, { cursor: "pointer" }]}
        className="flex-a-c-j-c"
        onClick={onIconClick}
      >
        <IconLoop />
      </button>
    </div>
  );
}

SearchInputWithClickableIcon.propTypes = {
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  onIconClick: PropTypes.func,
  className: PropTypes.string,
};
